<template>
  <div>
    <div
      class="text-h6 text-sm-h4 my-4 d-flex justify-space-between align-center"
    >
      B2C курсы
    </div>

    <!-- Верхняя панель: меню колонок + кнопки добавления курса. Активные/
         архивные и «только оплаченные» убраны — статус заказа теперь выбирается
         через универсальный фильтр-дропдаун ниже, а активность не фильтруется. -->
    <div
      class="text-h6 text-sm-h4 my-4 d-flex justify-end align-center flex-wrap"
    >
      <div class="d-flex align-center">
        <!-- Выбор видимых колонок таблицы — у пользователя 13 потенциальных
             колонок, по умолчанию включены ключевые. Видимость в памяти,
             переживёт только текущую сессию. -->
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="custom-btn-outlined mr-2"
              elevation="0"
              v-bind="attrs"
              v-on="on"
            >
              Колонки
              <v-icon right small>mdi-format-columns</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              v-for="col in availableColumns"
              :key="col.value"
              @click.stop="toggleColumn(col.value)"
            >
              <v-list-item-icon class="mr-2">
                <v-icon small>
                  {{
                    visibleColumns.includes(col.value)
                      ? "mdi-check-box-outline"
                      : "mdi-checkbox-blank-outline"
                  }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ col.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          class="white--text mr-2 custom-btn-filled"
          elevation="0"
          @click="addNewSession"
        >
          Добавить
          <v-icon right small>mdi-arrow-right</v-icon>
        </v-btn>
        <v-btn
          class="custom-btn-outlined"
          elevation="0"
          @click="addCustomCourse"
        >
          Индивидуальный курс
          <v-icon right small>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>

    <v-container fluid class="mx-0 px-0 my-0 py-0">
      <div
        class="pa-3 pa-sm-6"
        style="
          background-color: white;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        "
      >
        <!-- Ряд 1: основные текстовые поля поиска -->
        <v-row align="center" dense>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filters.orderNumber"
              label="Номер заказа"
              append-icon="mdi-magnify"
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              single-line
              hide-details
              @input="debouncedSearch"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filters.customerName"
              label="ФИО клиента"
              append-icon="mdi-magnify"
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              single-line
              hide-details
              @input="debouncedSearch"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filters.customerEmail"
              label="Email"
              append-icon="mdi-magnify"
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              single-line
              hide-details
              @input="debouncedSearch"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filters.customerPhone"
              label="Телефон"
              append-icon="mdi-magnify"
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              single-line
              hide-details
              @input="debouncedSearch"
            />
          </v-col>
        </v-row>

        <!-- Ряд 2: пациент, врач, период -->
        <v-row align="center" dense>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filters.patientFio"
              label="ФИО пациента"
              append-icon="mdi-magnify"
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              single-line
              hide-details
              @input="debouncedSearch"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filters.assignedBy"
              label="Назначил (имя/email)"
              append-icon="mdi-magnify"
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              single-line
              hide-details
              @input="debouncedSearch"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="filters.courseName"
              label="Название курса"
              append-icon="mdi-magnify"
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              single-line
              hide-details
              @input="debouncedSearch"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRange"
                  label="Период"
                  append-outer-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:append-outer="menu = true"
                  :class="filterFieldClass"
                  :style="filterFieldStyle + ';padding-right:12px'"
                  flat
                  solo
                  single-line
                  hide-details
                />
              </template>
              <v-date-picker v-model="dates" range scrollable>
                <v-spacer />
                <v-btn text color="primary" @click="resetDates">Сбросить</v-btn>
                <v-btn text color="primary" @click="onDateSelected"
                  >Поиск</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <!-- Ряд 3: справочники-фильтры (этап / статус / источник) + сброс всего -->
        <v-row align="center" dense class="mb-2">
          <v-col cols="12" md="3">
            <v-select
              v-model="filters.stage"
              :items="stageItems"
              label="Этап курса"
              clearable
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              hide-details
              @change="immediateSearch"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filters.orderStatus"
              :items="statusItems"
              label="Статус заказа"
              clearable
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              hide-details
              @change="immediateSearch"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filters.orderSource"
              :items="sourceItems"
              label="Источник"
              clearable
              :class="filterFieldClass"
              :style="filterFieldStyle"
              flat
              solo
              hide-details
              @change="immediateSearch"
            />
          </v-col>
          <v-col cols="12" md="3" class="d-flex align-center justify-end">
            <v-btn
              text
              color="primary"
              :disabled="!hasActiveFilters"
              @click="resetFilters"
            >
              <v-icon left small>mdi-filter-remove-outline</v-icon>
              Сбросить фильтры
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          height="calc(100vh - 420px)"
          :headers="displayedHeaders"
          :items="orders"
          :loading="loading"
          item-key="id"
          :mobile-breakpoint="0"
          class="table dense-table"
          hide-default-footer
          disable-pagination
          fixed-header
          dense
          multi-sort
          loading-text="Загрузка... Пожалуйста, подождите"
          style="cursor: pointer"
          @click:row="showOrderDetails"
        >
          <!-- Колонка «Кому» объединяет customer.name и patient.fio, чтобы
               в одной ячейке было видно и плательщика, и фактического получателя
               курса (если он отличается). -->
          <template slot="item.recipient" slot-scope="{ item }">
            <div class="d-flex flex-column">
              <span>{{ (item.customer && item.customer.name) || "—" }}</span>
              <span
                v-if="
                  item.patient &&
                  item.patient.fio &&
                  item.patient.fio !== (item.customer && item.customer.name)
                "
                class="text-caption text--secondary"
              >
                <v-icon x-small class="mr-1">mdi-account-injury-outline</v-icon>
                {{ item.patient.fio }}
              </span>
            </div>
          </template>

          <template slot="item.customer.name" slot-scope="{ item }">
            {{ (item.customer && item.customer.name) || "—" }}
          </template>
          <template slot="item.customer.email" slot-scope="{ item }">
            {{ (item.customer && item.customer.email) || "—" }}
          </template>
          <template slot="item.customer.phone" slot-scope="{ item }">
            {{ (item.customer && item.customer.phone) || "—" }}
          </template>
          <template slot="item.patient.fio" slot-scope="{ item }">
            <span v-if="item.patient && item.patient.fio">{{
              item.patient.fio
            }}</span>
            <span v-else class="text--disabled">—</span>
          </template>

          <template slot="item.custom_course_name" slot-scope="{ item }">
            <span v-if="item.custom_course_name" class="course-name-cell">{{
              item.custom_course_name
            }}</span>
            <span v-else class="text--disabled">—</span>
          </template>

          <template slot="item.stage" slot-scope="{ item }">
            <span v-if="item.stage">{{
              stageLabels[item.stage] || item.stage
            }}</span>
            <span v-else class="text--disabled">—</span>
          </template>

          <template slot="item.order_status" slot-scope="{ item }">
            <v-chip
              :color="statusColor(item.order_status)"
              text-color="white"
              x-small
            >
              {{ statusLabels[item.order_status] || item.order_status }}
            </v-chip>
          </template>

          <template slot="item.order_source" slot-scope="{ item }">
            <span>{{
              sourceLabels[item.order_source] || item.order_source || "—"
            }}</span>
          </template>

          <template slot="item.assignedBy" slot-scope="{ item }">
            <span v-if="item.assignedBy">{{
              formatAssignedBy(item.assignedBy)
            }}</span>
            <span v-else class="text--disabled">—</span>
          </template>

          <template slot="item.created_at" slot-scope="{ item }">
            <span v-if="item.created_at">{{
              formatDate(item.created_at)
            }}</span>
          </template>

          <template slot="item.actions" slot-scope="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="copyCourseLink(item)"
                  color="primary"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Скопировать ссылку на курс</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="resetSessionTimer(item)"
                  color="primary"
                >
                  <v-icon small>mdi-timer-off</v-icon>
                </v-btn>
              </template>
              <span>Сбросить таймаут следующей сессии</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="resetViewProgress(item)"
                  color="primary"
                >
                  <v-icon small>mdi-play-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Сбросить прогресс просмотра текущей сессии</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="resetCourse(item)"
                  color="warning"
                >
                  <v-icon small>mdi-restart</v-icon>
                </v-btn>
              </template>
              <span>Полностью сбросить курс в начальное состояние</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="closeCourse(item)"
                  color="primary"
                >
                  <v-icon small>mdi-check-circle</v-icon>
                </v-btn>
              </template>
              <span>Закрыть курс</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <v-snackbar v-model="showPopup" :color="popupColor" timeout="3000">
      {{ popupMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import ApiService from "@/api/ApiService";
import moment from "moment";
import B2C_Form from "@/components/B2C_Form.vue";
import B2C_CustomCourseForm from "@/components/B2C_CustomCourseForm.vue";
import { mapActions, mapGetters } from "vuex";
import NSApi from "@/api/NSApi";
import SelectProductsFormB2C from "@/components/SelectProductsFormB2C.vue";
import SelectCourseStage from "@/components/SelectCourseStage.vue";
import OrderSessionsModal from "@/components/OrderSessionsModal.vue";
import { COURSE_STAGES, ROLE_TRANSLATIONS } from "@/utils/constants";

// Дефолтное значение фильтров — отдельная константа, чтобы reset через
// Object.assign не тянул реактивные ссылки и работал по значению.
const DEFAULT_FILTERS = Object.freeze({
  orderNumber: "",
  customerName: "",
  customerEmail: "",
  customerPhone: "",
  patientFio: "",
  assignedBy: "",
  courseName: "",
  stage: null,
  orderStatus: null,
  orderSource: null,
});

export default {
  name: "B2CView",
  data() {
    return {
      // Все доступные колонки таблицы. По полю value позже фильтруем в
      // displayedHeaders. Колонки, у которых defaultVisible=false, скрыты по
      // умолчанию (включается через меню «Колонки»).
      allHeaders: [
        {
          text: "Номер заказа",
          value: "order_number",
          width: "8%",
          defaultVisible: true,
        },
        {
          text: "ФИО клиента",
          value: "customer.name",
          width: "12%",
          defaultVisible: true,
        },
        {
          text: "Email",
          value: "customer.email",
          width: "12%",
          defaultVisible: true,
        },
        {
          text: "Телефон",
          value: "customer.phone",
          width: "10%",
          defaultVisible: false,
        },
        {
          text: "ФИО пациента",
          value: "patient.fio",
          width: "12%",
          defaultVisible: true,
        },
        {
          text: "Курс",
          value: "custom_course_name",
          width: "14%",
          defaultVisible: true,
        },
        { text: "Этап", value: "stage", width: "8%", defaultVisible: false },
        {
          text: "Статус",
          value: "order_status",
          width: "6%",
          defaultVisible: true,
        },
        {
          text: "Источник",
          value: "order_source",
          width: "8%",
          defaultVisible: false,
        },
        {
          text: "Назначил",
          value: "assignedBy",
          width: "10%",
          defaultVisible: true,
        },
        {
          text: "Текущая сессия",
          value: "order_data[0].active_session",
          width: "10%",
          defaultVisible: true,
        },
        {
          text: "Создан",
          value: "created_at",
          width: "8%",
          defaultVisible: false,
        },
        {
          text: "Действия",
          value: "actions",
          width: "14%",
          defaultVisible: true,
          sortable: false,
        },
      ],
      visibleColumns: [],
      dates: [],
      orders: [],
      page: 1,
      loading: false,
      hasMore: true,
      menu: false,
      dateRange: "",
      searchTimeout: null,
      showPopup: false,
      popupMessage: "",
      popupColor: "",
      filters: { ...DEFAULT_FILTERS },
      stageLabels: COURSE_STAGES,
      // Текстовки для статусов и источников — в одном месте, чтобы и фильтр-
      // дропдаун, и колонка таблицы использовали одинаковые лейблы.
      // Префиксы соответствуют order_counters: M = ручное создание из админки,
      // U = портал Upmind (лэндинг), N = портал Neurobica.
      statusLabels: {
        pending: "Ожидает оплаты",
        paid: "Оплачен",
        completed: "Завершён",
        cancelled: "Отменён",
      },
      sourceLabels: {
        M: "Создан вручную через админку",
        U: "Портал Upmind",
        N: "Портал Neurobica",
        B: "B2C / Пациент",
      },
      roleLabels: ROLE_TRANSLATIONS,
      filterFieldClass: "mb-3",
      filterFieldStyle: "border: 1px solid #23919e; border-radius: 6px",
    };
  },
  computed: {
    ...mapGetters(["stagedCategories"]),
    availableColumns() {
      return this.allHeaders.map((h) => ({ text: h.text, value: h.value }));
    },
    displayedHeaders() {
      return this.allHeaders.filter((h) =>
        this.visibleColumns.includes(h.value)
      );
    },
    stageItems() {
      return Object.entries(this.stageLabels).map(([value, text]) => ({
        value,
        text,
      }));
    },
    statusItems() {
      return Object.entries(this.statusLabels).map(([value, text]) => ({
        value,
        text,
      }));
    },
    sourceItems() {
      return Object.entries(this.sourceLabels).map(([value, text]) => ({
        value,
        text,
      }));
    },
    hasActiveFilters() {
      const f = this.filters;
      return (
        !!f.orderNumber ||
        !!f.customerName ||
        !!f.customerEmail ||
        !!f.customerPhone ||
        !!f.patientFio ||
        !!f.assignedBy ||
        !!f.courseName ||
        !!f.stage ||
        !!f.orderStatus ||
        !!f.orderSource ||
        (this.dates && this.dates.length > 0)
      );
    },
  },
  methods: {
    ...mapActions("modals", ["showModalForm"]),
    ...mapActions("products", ["request_products"]),
    ...mapActions(["request_stagedCategories"]),

    toggleColumn(value) {
      const idx = this.visibleColumns.indexOf(value);
      if (idx === -1) {
        this.visibleColumns.push(value);
      } else {
        // Не даём скрыть последнюю колонку — иначе таблица станет пустой
        if (this.visibleColumns.length > 1) {
          this.visibleColumns.splice(idx, 1);
        }
      }
    },

    formatAssignedBy(user) {
      if (!user) return "—";
      const fullName = [user.first_name, user.last_name]
        .filter(Boolean)
        .join(" ")
        .trim();
      if (fullName) return fullName;
      return user.email || `User #${user.id}`;
    },

    formatDate(value) {
      if (!value) return "";
      return moment(value).format("DD.MM.YYYY HH:mm");
    },

    statusColor(status) {
      const map = {
        pending: "grey",
        paid: "blue",
        completed: "green",
        cancelled: "red",
      };
      return map[status] || "grey";
    },

    // Параметры запроса собираются по всем непустым фильтрам. customerName/Email/
    // startDate/endDate сохраняем как старые имена — бэк всё ещё их понимает,
    // плюс понимает новые параметры из getAllOrders. Фильтр active больше не
    // отправляем — бэк теперь показывает и активные, и архивные заказы вместе.
    buildQuery() {
      const params = {
        page: this.page,
      };
      const f = this.filters;
      if (f.orderNumber) params.orderNumber = f.orderNumber;
      if (f.customerName) params.customerName = f.customerName;
      if (f.customerEmail) params.customerEmail = f.customerEmail;
      if (f.customerPhone) params.customerPhone = f.customerPhone;
      if (f.patientFio) params.patientFio = f.patientFio;
      if (f.assignedBy) params.assignedBy = f.assignedBy;
      if (f.courseName) params.courseName = f.courseName;
      if (f.stage) params.stage = f.stage;
      if (f.orderStatus) params.orderStatus = f.orderStatus;
      if (f.orderSource) params.orderSource = f.orderSource;
      if (this.dates && this.dates.length === 2) {
        params.startDate = this.dates[0];
        params.endDate = this.dates[1];
      }
      return params;
    },

    async fetchOrders(loadMore = false) {
      if (this.loading || (!this.hasMore && loadMore)) return;

      this.loading = true;
      try {
        const response = await ApiService.get("v1/orders", this.buildQuery());
        const newOrders = response.data?.data || [];
        this.orders = loadMore ? [...this.orders, ...newOrders] : newOrders;
        this.hasMore = !!response.data?.has_more;
        if (this.hasMore) this.page++;
      } catch (error) {
        console.error("Ошибка при загрузке заказов:", error);
      } finally {
        this.loading = false;
      }
    },

    debouncedSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.immediateSearch(), 500);
    },

    immediateSearch() {
      this.page = 1;
      this.hasMore = true;
      this.fetchOrders();
    },

    resetFilters() {
      this.filters = { ...DEFAULT_FILTERS };
      this.dates = [];
      this.dateRange = "";
      this.immediateSearch();
    },

    resetDates() {
      this.dates = [];
      this.dateRange = "";
      this.menu = false;
      this.immediateSearch();
    },

    onDateSelected() {
      this.menu = false;
      this.page = 1;
      this.hasMore = true;
      if (this.dates.length === 1) {
        // Когда выбран только один день — превращаем в диапазон от начала до конца этого дня
        this.dates = [
          moment(this.dates[0]).startOf("day").format("YYYY-MM-DD"),
          moment(this.dates[0]).endOf("day").format("YYYY-MM-DD"),
        ];
      } else {
        this.dates = this.sortDates(this.dates);
      }
      this.dateRange = this.dates.join(" — ");
      this.fetchOrders();
    },

    sortDates(dates) {
      return dates.slice().sort((a, b) => new Date(a) - new Date(b));
    },

    // === Создание новых курсов (поведение прежнее) ===
    addNewSession() {
      this.showModalForm({
        component: B2C_Form,
        title: "Новый B2C курс",
        desc: "",
      })
        .then((formValue) => {
          // Ответственный менеджер приходит вместе с данными клиента — отделяем
          // его, чтобы не попал в объект customer (там только имя/email/телефон/возраст).
          const { bitrix_manager_id, ...customer } = formValue;
          return this.showModalForm({
            component: SelectProductsFormB2C,
            title: "Выбор продуктов для курса",
            desc: "",
            width: this.$vuetify.breakpoint.smAndUp
              ? "800px"
              : this.$vuetify.breakpoint.width,
            contentClass: "border-radius-30px",
          }).then((category) => {
            const stagedCategory = this.stagedCategories.find(
              (c) => c.id === category
            );
            if (stagedCategory && stagedCategory.stages != null) {
              return this.showModalForm({
                component: SelectCourseStage,
                title: "Выбор этапа курса",
                value: category,
              }).then((stage) => ({
                customer,
                category,
                stage,
                bitrix_manager_id,
              }));
            }
            return { customer, category, bitrix_manager_id };
          });
        })
        .then(({ customer, category, stage, bitrix_manager_id }) =>
          NSApi._instance.doB2C_Course(
            customer,
            category,
            stage,
            undefined,
            bitrix_manager_id
          )
        )
        .then(this.immediateSearch);
    },

    addCustomCourse() {
      this.showModalForm({
        component: B2C_CustomCourseForm,
        title: "Новый индивидуальный курс",
        desc: "",
      })
        .then((customerData) => {
          const customCourseName = customerData.customCourseName;
          const bitrixManagerId = customerData.bitrix_manager_id;
          const customer = {
            email: customerData.email,
            name: customerData.name,
            phone: customerData.phone,
            age: customerData.age,
          };
          return this.showModalForm({
            component: SelectProductsFormB2C,
            title: "Выбор продуктов для курса",
            desc: "",
            width: this.$vuetify.breakpoint.smAndUp
              ? "800px"
              : this.$vuetify.breakpoint.width,
            contentClass: "border-radius-30px",
          }).then((category) => {
            const stagedCategory = this.stagedCategories.find(
              (c) => c.id === category
            );
            if (stagedCategory && stagedCategory.stages != null) {
              return this.showModalForm({
                component: SelectCourseStage,
                title: "Выбор этапа курса",
                value: category,
              }).then((stage) => ({
                customer,
                category,
                stage,
                customCourseName,
                bitrixManagerId,
              }));
            }
            return { customer, category, customCourseName, bitrixManagerId };
          });
        })
        .then(
          ({ customer, category, stage, customCourseName, bitrixManagerId }) =>
            NSApi._instance.doB2C_Course(
              customer,
              category,
              stage,
              customCourseName,
              bitrixManagerId
            )
        )
        .then(this.immediateSearch);
    },

    // === Управление сессиями курса (поведение прежнее) ===
    copyCourseLink(order) {
      const link = order.order_data?.[0]?.link;
      if (!link) {
        this.showSnackbar(
          "Ссылка не скопирована! Курс не оплачен или не активен.",
          "error"
        );
        return;
      }
      navigator.clipboard
        .writeText(link)
        .then(() => this.showSnackbar("Ссылка успешно скопирована!", "success"))
        .catch((err) => {
          this.showSnackbar(
            "Ошибка копирования ссылки! Обратитесь к администратору.",
            "error"
          );
          console.error(err);
        });
    },

    async resetSessionTimer(order) {
      try {
        await ApiService.post(
          `v1/orders/${order.order_number}/reset_session_timer`
        );
        this.showSnackbar("Таймаут сессии успешно сброшен!", "success");
      } catch (err) {
        this.showSnackbar("Ошибка сброса таймаута сессии!", "error");
        console.error(err);
      }
    },

    async resetViewProgress(order) {
      try {
        await ApiService.post(
          `v1/orders/${order.order_number}/reset_view_progress`
        );
        this.showSnackbar("Прогресс просмотра успешно сброшен!", "success");
      } catch (err) {
        this.showSnackbar("Ошибка сброса прогресса просмотра!", "error");
        console.error(err);
      }
    },

    async resetCourse(order) {
      try {
        await ApiService.post(`v1/orders/${order.order_number}/reset_course`);
        this.showSnackbar("Курс полностью сброшен!", "success");
        this.fetchOrders();
      } catch (err) {
        this.showSnackbar("Ошибка полного сброса курса!", "error");
        console.error(err);
      }
    },

    async closeCourse(order) {
      try {
        await ApiService.post(`v1/orders/${order.order_number}/close_course`);
        this.showSnackbar("Курс успешно закрыт!", "success");
        this.fetchOrders();
      } catch (err) {
        this.showSnackbar("Ошибка закрытия курса!", "error");
        console.error(err);
      }
    },

    async showOrderDetails(order) {
      try {
        // Запрашиваем подробный заказ — нужно получить orderData[0].id, чтобы
        // потом вытащить сессии через /v1/videoOrder.
        const orderResponse = await ApiService.get(
          `v1/orders/${order.order_number}`
        );
        const orderData = orderResponse.data;

        if (!orderData?.order_data?.length) {
          this.showSnackbar("Данные заказа не найдены", "error");
          return;
        }

        const orderDataItem = orderData.order_data[0];
        const videoOrderResponse = await ApiService.get(
          `v1/videoOrder/${orderDataItem.id}`
        );
        const fullOrderData = videoOrderResponse.data;
        const videos = fullOrderData?.user_products?.[0]?.videos || [];

        if (!videos.length) {
          this.showSnackbar("В заказе нет доступных сессий", "warning");
          return;
        }

        // Передаём в модалку всю шапочную инфу о курсе — она там показывает
        // даты/этап/статус, чтобы не тянуть это второй раз.
        this.showModalForm({
          component: OrderSessionsModal,
          width: this.$vuetify.breakpoint.smAndUp ? "70%" : "90%",
          orderNumber: order.order_number,
          orderDataId: orderDataItem.id,
          courseMeta: {
            name:
              order.custom_course_name ||
              fullOrderData?.user_products?.[0]?.name ||
              "Курс",
            originalProductName: orderDataItem.course_name || null,
            stage: order.stage,
            status: fullOrderData?.user_products?.[0]?.status,
            createdAt: order.created_at,
            endDate: fullOrderData?.user_products?.[0]?.end_date,
            lastWatch:
              fullOrderData?.user_products?.[0]?.last_watch_time_update,
            assignedBy: order.assignedBy
              ? this.formatAssignedBy(order.assignedBy)
              : null,
            patient: order.patient?.fio || null,
          },
          sessions: videos.map((video) => ({
            ...video,
            playback_availability_time: video.playback_availability_time
              ? new Date(video.playback_availability_time)
              : null,
            viewed_at: video.viewed_at ? new Date(video.viewed_at) : null,
          })),
        });
      } catch (error) {
        console.error("Ошибка загрузки сессий заказа:", error);
        this.showSnackbar("Ошибка загрузки сессий заказа", "error");
      }
    },

    handleScroll(event) {
      const container = event.target;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 50
      ) {
        this.fetchOrders(true);
      }
    },

    showSnackbar(message, color) {
      this.popupMessage = message;
      this.popupColor = color;
      this.showPopup = true;
    },
  },

  mounted() {
    // Дефолтные колонки берём из allHeaders.defaultVisible — это «разумные»
    // 7-8 колонок, остальные пользователь включает вручную.
    this.visibleColumns = this.allHeaders
      .filter((h) => h.defaultVisible)
      .map((h) => h.value);

    this.request_products();
    this.request_stagedCategories();
    this.fetchOrders();

    this.$nextTick(() => {
      const container = this.$el.querySelector(".v-data-table__wrapper");
      if (container) container.addEventListener("scroll", this.handleScroll);
    });
  },

  beforeDestroy() {
    const container = this.$el.querySelector(".v-data-table__wrapper");
    if (container) container.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
.custom-btn-filled {
  background-color: #d86568 !important;
  border-radius: 24px;
  height: 48px;
  padding: 0 24px;
  text-transform: none;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
}

.custom-btn-filled:hover {
  background-color: #c75558 !important;
}

.custom-btn-outlined {
  background-color: transparent !important;
  border: 2px solid #d86568 !important;
  color: #d86568 !important;
  border-radius: 24px;
  height: 48px;
  padding: 0 24px;
  text-transform: none;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
}

.custom-btn-outlined:hover {
  background-color: rgba(216, 101, 104, 0.1) !important;
}

/* Длинные кастомные названия курсов («Курс UpMIND+ "Помощь родителям"…»)
   режутся троеточием — иначе строка таблицы вырастает на 2-3 строки и убивает
   плотность. На hover показывается tooltip с полным названием. */
.course-name-cell {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
